<script setup lang="ts">
import type { Coords } from '@glow/shared/lib/coords';
import type { RouteLocationRaw } from 'vue-router';
import ClosestStations, {
  type ClosestMetroStation,
} from './ClosestStations.vue';

export type PartnerLocationData = {
  id: number;
  name: string;
  link?: RouteLocationRaw;
  location: Coords;
  metroStations?: ClosestMetroStation[];
};

const props = defineProps<{
  location: PartnerLocationData;
}>();
</script>

<template>
  <address class="location">
    <NuxtLink :to="props.location.link" class="location__name">
      {{ location.name }}
    </NuxtLink>
    <ClosestStations
      :metro-stations="props.location.metroStations ?? []"
      :location="location.location"
    />
  </address>
</template>

<style scoped lang="scss">
.location {
  display: flex;
  flex-direction: column;
  font-style: normal;

  &__name {
    padding-bottom: 8px;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: var(--app-color-black);

    @include media-breakpoint-down(sm) {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
    }
  }
}
</style>
